import React from "react";
import CancelTicketPayment from "../components/BuyTicket/PaymentMessage/CancelTicketPayment";
import Header from "../components/Header/Header";
import Footer from "../components/Footer/Footer";
const CancelTicketsPaymentPage = () => {
  return (
    <>
      <Header />
      <CancelTicketPayment />
      <Footer />
    </>
  );
};

export default CancelTicketsPaymentPage;
